import { AxiosResponse } from 'axios';
import BaseAPI from "../api";
import { ONLINE_COURSE_PAYMENT } from '../../pages/cms/course-online/manage-payment/enum/enum.payment';

const path: string = "online-course-payment";

export type paymentList = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    keyword?: string;
    start_date?: string;
    end_date?: string;
    status?: string;
}

export type updateStatusPaymentOnlineCourse = {
    is_confirm: ONLINE_COURSE_PAYMENT
}

export class OnlineCoursePaymentApi extends BaseAPI {
    static paymentList(params: paymentList): Promise<AxiosResponse> {
        return this.api.get(`${path}/list`, { params: { ...params } })
    }
    static updateStatus(id_online_course_payment: number, body: updateStatusPaymentOnlineCourse): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_online_course_payment}`, body)
    }
    static findOne(id_online_course_payment: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_online_course_payment}`)
    }
    static deleted(id_online_course_payment: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_online_course_payment}`)
    }
}